import React from "react";
import Input, { InputProps } from "modules/ui/shared/Input/Input";
import Label from "modules/ui/components/Label/Label";
import InputError from "modules/ui/shared/InputError/InputError";

export interface InputFieldProps extends InputProps {
    label?: React.ReactNode;
    error?: string;
    helperText?: React.ReactNode;
}

const InputField = React.forwardRef<HTMLInputElement, InputFieldProps>(
    (
        {
            label,
            error,
            helperText,
            ...inputProps
        },
        ref
    ) => {
        return (
            <div className="space-y-1 overflow-hidden">
                {label && <Label isInvalid={!!error}>{label}</Label>}
                <Input ref={ref} isInvalid={!!error} {...inputProps} />
                {helperText && !error && <p className="text-xs text-neutral-500 dark:text-neutral-400">{helperText}</p>}
                {error && <InputError>{error}</InputError>}
            </div>
        );
    }
);

export default InputField;
